import axios, { AxiosInstance, AxiosResponse } from "axios";

class ApiService {
  private api: AxiosInstance;
  private baseURL: string;
  private uploadEndpoint: string;

  constructor() {
    this.baseURL =
      process.env.REACT_APP_API_BASE_URL || "http://localhost:3000";
    this.uploadEndpoint = process.env.REACT_APP_UPLOAD_ENDPOINT || "/upload";

    this.api = axios.create({
      baseURL: this.baseURL,
      timeout: 30000, // 30 seconds timeout for file uploads
    });
  }

  // Set the authorization token for requests
  setAuthToken(token: string | null) {
    if (token) {
      this.api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } else {
      delete this.api.defaults.headers.common["Authorization"];
    }
  }

  async uploadFile(
    file: File,
    onProgress?: (progress: number) => void
  ): Promise<AxiosResponse> {
    const formData = new FormData();
    formData.append("files", file);

    return this.api.post(this.uploadEndpoint, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (progressEvent) => {
        if (onProgress && progressEvent.total) {
          const progress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          onProgress(progress);
        }
      },
    });
  }

  // Health check endpoint (optional)
  async healthCheck(): Promise<AxiosResponse> {
    return this.api.get("/health");
  }
}

export const apiService = new ApiService();
